/**
 * Carousel
 *
 * Drives any grid marked data-carousel that the stylesheet has turned into a
 * horizontally snapping track. Scrolling itself is native — this only adds the
 * arrows and keeps the "N of M" counter in step, so the block still works by
 * swiping if the script never runs.
 *
 * The controls sit outside the track and find it through data-carousel-for, so
 * they do not scroll away with the slides.
 */
(function () {
    'use strict';

    function init() {
        var tracks = document.querySelectorAll('[data-carousel]');

        Array.prototype.forEach.call(tracks, function (track) {
            var controls = document.querySelector('[data-carousel-for="' + track.id + '"]');

            if (!controls) {
                return;
            }

            var slides = track.children;

            if (slides.length < 2) {
                return;
            }

            var counter = controls.querySelector('[data-carousel-current]');
            var prev = controls.querySelector('[data-carousel-prev]');
            var next = controls.querySelector('[data-carousel-next]');

            // Measured rather than assumed: the slide width and gutter both
            // come from clamped CSS, so they change with the viewport.
            function step() {
                var style = window.getComputedStyle(track);
                var gap = parseInt(style.columnGap || style.gap, 10) || 0;

                return slides[0].getBoundingClientRect().width + gap;
            }

            function index() {
                return Math.round(track.scrollLeft / step());
            }

            function scrollToIndex(i) {
                var last = slides.length - 1;
                var target = Math.max(0, Math.min(i, last));

                track.scrollTo({ left: target * step(), behavior: 'smooth' });
            }

            function sync() {
                var i = Math.max(0, Math.min(index(), slides.length - 1));

                if (counter) {
                    counter.textContent = String(i + 1);
                }

                // A control that cannot go anywhere is disabled rather than
                // hidden, so the pair does not shift about as you page.
                if (prev) {
                    prev.disabled = i === 0;
                }

                // When several slides show at once the track runs out of room
                // before the last slide reaches the start, so "at the end"
                // means scrolled as far as it goes.
                if (next) {
                    var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;

                    next.disabled = i === slides.length - 1 || atEnd;
                }
            }

            if (prev) {
                prev.addEventListener('click', function () {
                    scrollToIndex(index() - 1);
                });
            }

            if (next) {
                next.addEventListener('click', function () {
                    scrollToIndex(index() + 1);
                });
            }

            track.addEventListener('scroll', sync, { passive: true });
            window.addEventListener('resize', sync);

            sync();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
